import React from 'react'
import './RaiseComplaintModal.css'
import CircledClose from 'SVGPath/circledClose.svg'
import { fireClevertapEvent } from 'AccountsUtils'
import Button from 'Lib/Buttons'

const RaiseComplaintDesktopModal = props => {
  const { header, content, primaryButton, successButton, type, setComplaintToggle } = props

  const primaryButtonAction = () => {
    if (typeof primaryButton.action === 'function') {
      primaryButton.action()
    }
  }

  const successButtonAction = () => {
    if (typeof successButton.action === 'function') {
      successButton.action()
    }
  }

  const closeModal = (e, closeModalBox) => {
    if (header.toLowerCase() === 'documents required') {
      fireClevertapEvent('View_documents_needed_shown_desktop')
    }
    e.stopPropagation()
    e.preventDefault()
    closeModalBox()
  }

  return (
    <React.Fragment>
      <div className="desktop-modal-case">
        <div className="desktop-modal-container-case p-4 min-max-h-50">
          <div className="flex flex-between flex-middle desktop-modal-header-case py-3">
            <p className="flex-1 fs-24 fw-600 px-4 py-4">{header}</p>
            <If condition={type !== 'fulfillment'}>
              <span
                className="desktop-modal-close-case px-4"
                onClick={e => closeModal(e, setComplaintToggle)}
              >
                <CircledClose />
              </span>
            </If>
          </div>
          <div
            className={`modal-content ${
              type === 'fulfillment' ? 'ta-c' : ''
            } apl-15 apr-15 apb-10 lh-title`}
          >
            {content}
          </div>
          <If
            condition={
              primaryButton &&
              primaryButton.visible &&
              (type === 'complaint' || type === 'callback_outbound' || type === 'sos')
            }
          >
            <div className="pt-3 px-8">
              <Button
                full={true}
                size="lg"
                type="secondary"
                className="tt-sentence fs-16 amr-10 w-100p h-10"
                onClick={primaryButtonAction}
              >
                {primaryButton.text}
              </Button>
            </div>
          </If>
          <If
            condition={
              successButton &&
              successButton.visible &&
              (type === 'fulfillment' ||
                type === 'processing' ||
                type === 'escalation' ||
                type === 'sos')
            }
          >
            <div className="pt-3 px-8">
              <Button
                full={true}
                size="lg"
                type="secondary"
                className="tt-sentence fs-16 amr-10 w-100p h-10"
                onClick={successButtonAction}
              >
                {successButton.text}
              </Button>
            </div>
          </If>
        </div>
      </div>
    </React.Fragment>
  )
}

export default RaiseComplaintDesktopModal
